// ======================================================
// 🔍 SCRIPT VERIFICA EMAIL PER FORM RECUPERO PASSWORD
// ======================================================

document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action*="/recover"]');
  if (!form) {
    console.error("❌ Form di recupero password non trovato!");
    return;
  }

  console.log("✅ Script recupero password caricato correttamente, form:", form);

  // Cache degli elementi DOM
  const elements = {
    emailInput: form.querySelector('input[type="email"]'),
    submitBtn: form.querySelector('button[type="submit"]')
  };

  // Stato
  const state = {
    emailVerified: false,
    emailExists: false
  };
  
  // Cache per evitare richieste duplicate
  const emailCache = new Map();

  // Debounce e controllo richieste in corso
  let checkTimeout = null;
  let currentRequest = null;
  let lastCheckedEmail = null;

  // Traccia ultimo invio per evitare troppe richieste a Shopify
  // Usa localStorage per persistere tra ricaricamenti della pagina
  const STORAGE_KEY = 'last_password_recovery_submit';
  const MIN_SUBMIT_DELAY = 60000; // 60 secondi minimo tra le richieste

  // Recupera l'ultimo timestamp dal localStorage
  let lastSubmitTime = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);

  // Se è passato abbastanza tempo, resetta il timestamp
  const now = Date.now();
  if (now - lastSubmitTime >= MIN_SUBMIT_DELAY) {
    lastSubmitTime = 0;
    localStorage.removeItem(STORAGE_KEY);
  }

  // Salva il testo originale del pulsante e disabilita all'inizio
  if (elements.submitBtn) {
    elements.submitBtn.setAttribute('data-original-text', elements.submitBtn.textContent);

    // Se è passato meno di 60 secondi dall'ultimo invio, disabilita il pulsante
    if (lastSubmitTime > 0 && (now - lastSubmitTime) < MIN_SUBMIT_DELAY) {
      const remainingTime = Math.ceil((MIN_SUBMIT_DELAY - (now - lastSubmitTime)) / 1000);
      elements.submitBtn.disabled = true;
      elements.submitBtn.style.opacity = '0.6';
      elements.submitBtn.style.cursor = 'not-allowed';
      elements.submitBtn.textContent = `Attendi ${remainingTime}s`;
      
        // Timer per aggiornare il testo e riabilitare il pulsante (se l'email è verificata)
      const countdownInterval = setInterval(() => {
        const currentTime = Date.now();
        const elapsed = currentTime - lastSubmitTime;
        const timeLeft = Math.ceil((MIN_SUBMIT_DELAY - elapsed) / 1000);
        
        if (timeLeft > 0 && elements.submitBtn) {
          elements.submitBtn.textContent = `Attendi ${timeLeft}s`;
        } else {
          clearInterval(countdownInterval);
          localStorage.removeItem(STORAGE_KEY);
          lastSubmitTime = 0;
          
          // Riabilita il pulsante solo se l'email è verificata ed esiste
          if (elements.submitBtn && state.emailVerified && state.emailExists) {
            elements.submitBtn.disabled = false;
            elements.submitBtn.style.opacity = '1';
            elements.submitBtn.style.cursor = 'pointer';
            const originalText = elements.submitBtn.getAttribute('data-original-text');
            if (originalText) {
              elements.submitBtn.textContent = originalText;
            }
          }
        }
      }, 1000);
    } else {
      // Altrimenti disabilita solo perché l'email non è verificata
      elements.submitBtn.disabled = true;
      elements.submitBtn.style.opacity = '0.6';
      elements.submitBtn.style.cursor = 'not-allowed';
    }
  }
  
  // Resetta lo stato quando l'utente modifica l'email
  elements.emailInput.addEventListener('input', function() {
    const currentEmail = this.value.trim();
    const verifiedEmail = this.getAttribute('data-verified-email') || '';
    
    // Se l'email è stata modificata rispetto a quella verificata, resetta lo stato
    if (state.emailVerified && currentEmail !== verifiedEmail) {
      state.emailVerified = false;
      state.emailExists = false;
      this.removeAttribute('data-verified-email');
      if (elements.submitBtn) {
        elements.submitBtn.disabled = true;
        elements.submitBtn.style.opacity = '0.6';
        elements.submitBtn.style.cursor = 'not-allowed';
      }
      removeEmailMessages();
    }
  });

  // Blocca il submit del form se l'email non esiste o non è verificata
  form.addEventListener('submit', function(e) {
    const email = elements.emailInput.value.trim();
    const submitTime = Date.now();
    
    // Controlla se è passato abbastanza tempo dall'ultimo invio
    if (submitTime - lastSubmitTime < MIN_SUBMIT_DELAY) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const remainingTime = Math.ceil((MIN_SUBMIT_DELAY - (submitTime - lastSubmitTime)) / 1000);
      const warning = document.createElement('div');
      warning.className = 'email-verification-message';
      warning.style.cssText = `
        margin-top: 8px;
        padding: 8px 10px;
        background: #fee2e2;
        border: 1px solid #fecaca;
        color: #991b1b;
        border-radius: 4px;
        font-size: 0.85rem;
      `;
      warning.textContent = `⏱️ Attendi ${remainingTime} secondi prima di richiedere nuovamente il link di recupero.`;
      removeEmailMessages();
      elements.emailInput.parentNode.appendChild(warning);
      return false;
    }
    
    // Se l'email non è stata verificata o non esiste, blocca il submit
    if (!state.emailVerified || !state.emailExists) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      if (!email) {
        showEmailInvalidWarning();
        return false;
      }
      
      if (!isValidEmail(email)) {
        showEmailInvalidWarning();
        return false;
      }
      
      // Se l'email è valida ma non è stata verificata ancora, mostra messaggio
      if (!state.emailVerified) {
        const warning = document.createElement('div');
        warning.className = 'email-verification-message';
        warning.style.cssText = `
          margin-top: 8px;
          padding: 8px 10px;
          background: #fee2e2;
          border: 1px solid #fecaca;
          color: #991b1b;
          border-radius: 4px;
          font-size: 0.85rem;
        `;
        warning.textContent = '❌ Verifica l\'email prima di inviare il form.';
        removeEmailMessages();
        elements.emailInput.parentNode.appendChild(warning);
        return false;
      }
      
      // Se l'email non esiste, mostra messaggio
      if (!state.emailExists) {
        showEmailNotRegisteredMessage(email);
        return false;
      }
      
      return false;
    }
    
    // Se arriva qui, l'email esiste e può procedere
    // Disabilita il pulsante per evitare click multipli
    if (elements.submitBtn) {
      elements.submitBtn.disabled = true;
      elements.submitBtn.textContent = 'Invio in corso...';
      elements.submitBtn.style.opacity = '0.6';
      elements.submitBtn.style.cursor = 'not-allowed';
    }
    
    // Salva il timestamp dell'invio in memoria e localStorage
    lastSubmitTime = submitTime;
    localStorage.setItem(STORAGE_KEY, submitTime.toString());
    
    // Riabilita il pulsante dopo 60 secondi (anche se la pagina viene ricaricata)
    setTimeout(() => {
      if (elements.submitBtn) {
        elements.submitBtn.disabled = false;
        const originalText = elements.submitBtn.getAttribute('data-original-text');
        if (originalText) {
          elements.submitBtn.textContent = originalText;
        }
        elements.submitBtn.style.opacity = '1';
        elements.submitBtn.style.cursor = 'pointer';
      }
    }, MIN_SUBMIT_DELAY);

    // Il recupero nativo di Shopify manda la mail solo ad account attivi con
    // email esatta: per account non attivi o anonimizzati da Delete Me il
    // backend invia lui l'email di attivazione account.
    e.preventDefault();
    recoverCustomer(email);
    return false;
  });

  async function recoverCustomer(email) {
    let action = 'native';
    try {
      const response = await fetch('/apps/account/recover-customer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
        signal: AbortSignal.timeout(15000)
      });
      action = (await response.json()).action || 'native';
    } catch (err) {
      console.error('❌ Errore recupero account:', err);
    }

    if (action === 'invite_sent') {
      showInviteSentMessage(email);
      return;
    }
    // form.submit() non riattiva il listener di submit
    form.submit();
  }

  function showInviteSentMessage(email) {
    removeEmailMessages();

    const message = document.createElement('div');
    message.className = 'email-verification-message';
    message.style.cssText = `
      margin-top: 10px;
      padding: 10px;
      background: #dcfce7;
      border: 1px solid #bbf7d0;
      color: #166534;
      border-radius: 4px;
      font-size: 0.85rem;
      line-height: 1.3;
    `;
    message.textContent = `✅ Ti abbiamo inviato un'email a ${email} con il link per attivare l'account e scegliere la password. Controlla anche la cartella spam.`;

    elements.emailInput.parentNode.appendChild(message);
  }

  // Funzione per verificare l'email con cache e debounce
  async function checkEmail(email) {
    // Se l'email è vuota, disabilita e resetta lo stato
    if (!email) {
      state.emailVerified = false;
      state.emailExists = false;
      if (elements.submitBtn) {
        elements.submitBtn.disabled = true;
        elements.submitBtn.style.opacity = '0.6';
        elements.submitBtn.style.cursor = 'not-allowed';
      }
      removeEmailMessages();
      return;
    }
    
    // Validazione base dell'email
    if (!isValidEmail(email)) {
      state.emailVerified = false;
      state.emailExists = false;
      showEmailInvalidWarning();
      if (elements.submitBtn) {
        elements.submitBtn.disabled = true;
        elements.submitBtn.style.opacity = '0.6';
        elements.submitBtn.style.cursor = 'not-allowed';
      }
      return;
    }
    
    // Se abbiamo già verificato questa email, usa la cache
    if (emailCache.has(email.toLowerCase())) {
      const cachedResult = emailCache.get(email.toLowerCase());
      if (cachedResult.exists) {
        handleEmailExists(email);
      } else {
        handleEmailNotExists(email);
      }
      return;
    }
    
    // Se c'è già una richiesta in corso per questa email, non fare nulla
    if (currentRequest && lastCheckedEmail === email.toLowerCase()) {
      return;
    }
    
    // Annulla il timeout precedente se presente
    if (checkTimeout) {
      clearTimeout(checkTimeout);
      checkTimeout = null;
    }
    
    // Mostra indicatore di ricerca
    const searchIndicator = createSearchIndicator();
    elements.emailInput.parentNode.appendChild(searchIndicator);
    
    // Salva la richiesta corrente
    currentRequest = true;
    lastCheckedEmail = email.toLowerCase();
    
    try {
      const response = await fetch("/apps/account/check-customer-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
        signal: AbortSignal.timeout(10000)
      });

      const data = await response.json();
      searchIndicator.remove();
      
      // Salva nella cache
      emailCache.set(email.toLowerCase(), data);
      
      // Limita la cache a 10 email per evitare memory leak
      if (emailCache.size > 10) {
        const firstKey = emailCache.keys().next().value;
        emailCache.delete(firstKey);
      }

      if (data.exists) {
        handleEmailExists(email);
      } else {
        handleEmailNotExists(email);
      }
    } catch (err) {
      console.error("❌ Errore durante la verifica email:", err);
      searchIndicator.remove();
      state.emailVerified = false;
      state.emailExists = false;
      handleEmailError(err);
      if (elements.submitBtn) {
        elements.submitBtn.disabled = true;
        elements.submitBtn.style.opacity = '0.6';
        elements.submitBtn.style.cursor = 'not-allowed';
      }
    } finally {
      // Reset della richiesta corrente
      currentRequest = null;
      lastCheckedEmail = null;
    }
  }

  elements.emailInput.addEventListener('blur', () => {
    const email = elements.emailInput.value.trim();
    // Debounce: aspetta 800ms prima di verificare
    if (checkTimeout) {
      clearTimeout(checkTimeout);
    }
    checkTimeout = setTimeout(() => {
      checkEmail(email);
    }, 800);
  });

  // Funzioni helper
  function removeEmailMessages() {
    document.querySelector('.email-verification-message')?.remove();
    document.querySelector('.email-search-indicator')?.remove();
  }

  function createSearchIndicator() {
    const searchIndicator = document.createElement('div');
    searchIndicator.className = 'email-search-indicator';
    searchIndicator.style.cssText = `
      font-size: 0.8rem;
      color: #d84c00;
      margin-top: 4px;
      font-style: italic;
      display: flex;
      align-items: center;
    `;
    searchIndicator.innerHTML = `
      <span style="display: inline-block; width: 12px; height: 12px; border: 2px solid #d84c00; border-radius: 50%; border-top-color: transparent; margin-right: 6px; animation: spin 1s linear infinite;"></span>
      Verifica email in corso...
    `;
    return searchIndicator;
  }

  function handleEmailExists(email) {
    state.emailExists = true;
    state.emailVerified = true;
    
    // Salva l'email verificata come attributo per verificare modifiche successive
    elements.emailInput.setAttribute('data-verified-email', email);
    
    // Rimuovi eventuali messaggi precedenti
    removeEmailMessages();
    
    // Abilita il pulsante "Invia link" se la mail esiste E se è passato abbastanza tempo dall'ultimo invio
    if (elements.submitBtn) {
      const currentTime = Date.now();
      const timeSinceLastSubmit = currentTime - lastSubmitTime;
      
      if (lastSubmitTime > 0 && timeSinceLastSubmit < MIN_SUBMIT_DELAY) {
        // Se non è passato abbastanza tempo, disabilita e mostra countdown
        const remainingTime = Math.ceil((MIN_SUBMIT_DELAY - timeSinceLastSubmit) / 1000);
        elements.submitBtn.disabled = true;
        elements.submitBtn.style.opacity = '0.6';
        elements.submitBtn.style.cursor = 'not-allowed';
        elements.submitBtn.textContent = `Attendi ${remainingTime}s`;
      } else {
        // Se è passato abbastanza tempo, abilita il pulsante
        elements.submitBtn.disabled = false;
        elements.submitBtn.style.opacity = '1';
        elements.submitBtn.style.cursor = 'pointer';
        // Ripristina il testo originale se presente
        const originalText = elements.submitBtn.getAttribute('data-original-text');
        if (originalText) {
          elements.submitBtn.textContent = originalText;
        }
      }
    }
  }

  function handleEmailNotExists(email) {
    state.emailExists = false;
    state.emailVerified = true;
    
    // Salva l'email verificata come attributo per verificare modifiche successive
    elements.emailInput.setAttribute('data-verified-email', email);
    
    // Mostra messaggio che la mail non è registrata
    showEmailNotRegisteredMessage(email);
    
    // Disabilita il pulsante se la mail non esiste
    if (elements.submitBtn) {
      elements.submitBtn.disabled = true;
      elements.submitBtn.style.opacity = '0.6';
      elements.submitBtn.style.cursor = 'not-allowed';
    }
  }

  async function handleEmailError(err) {
    let errorMessage = "Errore durante la verifica dell'email. Riprova.";
    
    if (err.name === 'AbortError') {
      errorMessage = "Server lento. Riprova più tardi.";
    } else if (err.response) {
      // Se c'è una risposta, controlla lo status
      const status = err.response.status;
      if (status === 429 || status === 503) {
        errorMessage = "Troppe richieste. Attendi qualche secondo e riprova.";
      }
    }
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'email-verification-message';
    errorDiv.style.cssText = `
      margin-top: 8px;
      padding: 8px 10px;
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #991b1b;
      border-radius: 4px;
      font-size: 0.85rem;
    `;
    errorDiv.textContent = errorMessage;
    
    elements.emailInput.parentNode.appendChild(errorDiv);
    setTimeout(() => errorDiv.remove(), 5000);
    
    // Se c'è stato un errore di rate limiting, disabilita la verifica per 30 secondi
    if (err.response && (err.response.status === 429 || err.response.status === 503)) {
      elements.emailInput.disabled = true;
      setTimeout(() => {
        elements.emailInput.disabled = false;
      }, 30000); // 30 secondi
    }
  }

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showEmailInvalidWarning() {
    removeEmailMessages();

    const warning = document.createElement('div');
    warning.className = 'email-verification-message';
    warning.style.cssText = `
      margin-top: 8px;
      padding: 8px 10px;
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #991b1b;
      border-radius: 4px;
      font-size: 0.85rem;
      line-height: 1.3;
    `;

    warning.innerHTML = `
      ❌ Inserisci un indirizzo email valido (es. nome@dominio.com)
    `;

    elements.emailInput.parentNode.appendChild(warning);
  }

  function showEmailNotRegisteredMessage(email) {
    removeEmailMessages();

    const message = document.createElement('div');
    message.className = 'email-verification-message';
    message.style.cssText = `
      margin-top: 10px;
      padding: 10px;
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #991b1b;
      border-radius: 4px;
      font-size: 0.85rem;
      line-height: 1.3;
    `;

    message.innerHTML = `
      ❌ L'email inserita non è registrata.
    `;

    elements.emailInput.parentNode.appendChild(message);
  }
});